import { removeSpace } from '../text'

import { MarkedRule } from '../../interface'

// 获取元素
export const getEle = (el: HTMLElement | string | undefined) => {
    if (typeof el === 'string') {
        return document.querySelectorAll(el)
    }

    return el || document
}

// 检查是否含有className
export const checkContainClassName = (element: HTMLElement, arr: string[]) =>
    element && element.classList && arr.some(v => element.classList.contains(v))

// 遍历父节点找到满足条件的节点
export const findElement = (element: HTMLElement, check: (e: HTMLElement) => boolean) => {
    let node: any = element

    do {
        if (!node || node === document.body) {
            return null
        }

        const res = check(node)

        if (res) {
            return node
        }

        node = node.parentNode
    } while (node)

    return null
}

// 遍历父节点查找特殊节点集合
export const findElementList = (element: HTMLElement, check: (e: HTMLElement) => boolean) => {
    let node: any = element

    const arr = []

    do {
        if (!node || node === document.body) {
            break
        }

        const res = check(node)

        if (res) {
            arr.push(res)
        }

        node = node.parentNode
    } while (node)

    return arr.reverse()
}

// 获取元素文本
export const getElementText = (element: HTMLElement): string => {
    if (!element) {
        return ''
    }

    const innerText = removeSpace(element.innerText?.split('\n')[0])

    const arialLabel = element.getAttribute('aria-label')
    const title = element.getAttribute('title')

    return innerText || title || (arialLabel && typeof arialLabel === 'string' ? arialLabel : '')
}

// 转化dateset
export const transLogDataset = (dataset: any) => {
    if (Object.prototype.toString.call(dataset) === '[object Object]') {
        return Object.keys(dataset).reduce((t, c) => {
            const bKey = c.replace('log', '')

            if (bKey) {
                t[bKey.replace(/^(\w).*$/, w => w.substring(0, 1).toLowerCase() + w.substring(1))] = dataset[c]
            }

            return t
        }, {})
    }

    return {}
}

// 解析节点上的dataset数据
export const readDataset = (element: HTMLElement) => {
    const role = element.getAttribute && element.getAttribute('role')
    const values = element.dataset

    const obj: any = {}

    if (values) {
        for (const key in values) {
            if (values.hasOwnProperty(key) && /^log.*$/.test(key)) {
                obj[key] = values[key]
            }
        }
    }

    if (role === 'switch') {
        obj.value = !(element.getAttribute('aria-checked') === 'true')
    }

    return obj
}

// 匹配需要打点的节点
export const matchLogElement = (element: HTMLElement, markedRules: MarkedRule[] | undefined): any => {
    let node: any = element

    do {
        if (!node || node === document.body) {
            return null
        }

        const data: any = readDataset(node)

        // @ts-ignore
        node.logData = data

        // 含有data-log-ignore属性，直接忽略
        if (data.logIgnore === 'true') {
            return null
        }

        // 含有data-log-*属性
        if (Object.keys(data).length) {
            return node
        }

        if (Array.isArray(markedRules)) {
            for (let o of markedRules) {
                const isValid = Object.keys(o).every(propName => {
                    const propValue = o[propName]

                    if (propName === 'nodeName') {
                        return node.nodeName.toUpperCase() === propValue
                    }

                    if (propName === 'className') {
                        if (propValue.startsWith('!')) {
                            const noSignPropValue = propValue.slice(1)

                            return !checkContainClassName(node, [noSignPropValue])
                        }

                        return checkContainClassName(node, [propValue])
                    }

                    return false
                })

                if (isValid) {
                    return node
                }
            }
        }

        node = node.parentNode
    } while (node)

    return null
}

// 根据xpath获取元素
export const getElementByXpath = (path: string) => {
    return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue
}

// 根据元素获取xpath
export const getXpathByElement = (element: any): any => {
    if (element.id !== '') return `//*[@id="${element.id}"]`
    if (element.tagName === 'html') return '/html[1]'
    if (element === document.body) return '/html[1]/body[1]'

    let ix = 0
    const siblings = element?.parentNode?.childNodes || []

    for (let i = 0; i < siblings.length; i++) {
        const sibling = siblings[i]
        if (sibling === element)
            return `${getXpathByElement(element.parentNode)}/${element.tagName.toLowerCase()}[${ix + 1}]`
        if (sibling.nodeType === 1 && sibling.tagName.toLowerCase() === element.tagName.toLowerCase()) ix++
    }

    return ''
}
